import { render, staticRenderFns } from "./TimeExpiredPopup.vue?vue&type=template&id=bc6c3d7c&scoped=true"
import script from "./TimeExpiredPopup.vue?vue&type=script&lang=js"
export * from "./TimeExpiredPopup.vue?vue&type=script&lang=js"
import style0 from "./TimeExpiredPopup.vue?vue&type=style&index=0&id=bc6c3d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6c3d7c",
  null
  
)

export default component.exports